import React from "react";
import ErrorModal from "../../components/Error/Error";
import Loading from "../../components/Loading/Loading";
import { useData } from "../../context/DataProvider";
import { richTextRenderer } from "../../utils/commonUtil";
import styles from "./AboutPage.module.scss";

interface HakkimizdaItem {
  baslik: string;
  altBaslik: string;
  aciklama: string;
  sira: number;
  id: string;
}

const AboutPage: React.FC = () => {
  const { hakkimizdaBasliklar, hakkimizdaGorsel, isLoading, error } = useData();

  const görsel = {
    kapakGorsel: "/assets/AboutLayer.png",
    id: "68a954a1-47e8-4dc5-b60c-08dd26723409",
    status: 1,
    createdDate: "2024-12-27T15:30:43.4672642",
    updatedDate: "2024-12-27T15:30:43.4835142",
  };

  if (isLoading) return <Loading />;
  if (error) return <ErrorModal message={error.message} />;

  /** Örnek veri. Gerçek projede API’den veya props ile gelebilir. */
  const data: HakkimizdaItem[] = [
    {
      baslik: "NEDİR?",
      altBaslik:
        "Güzel İzmir Hareketi, İzmir Büyükşehir Belediyesi öncülüğünde başlatılan, kamusal alan odaklı katılımcı bir harekettir.",
      aciklama:
        "İzmir’in kentsel ve kırsal kesimini kapsayan kamusal mekânların canlandırılması, kamusal mekânlara erişilebilirliğin artırılması, kullanımların çeşitlendirilmesi ve mevcut alanların iyileştirilmesi için tasarımcılarla İzmirlileri buluşturan bir oluşumdur. Kamusal alan sorunlarının iyileştirilmesinde küçük ölçekli eylemler üreten ve mekânın şekillendirilmesinde çözümler geliştirerek, uzun vadeli değişimi kurgulayabilen bir süreç olarak İzmir’in güzelleştirilmesi için; hızlı, hesaplı, hafif, hareketli, herkes için, herkesle 6H tasarım ilkelerini kapsamaktadır. Bu hareket, şehrin kamusal alanlarını yeniden canlandırarak yaşam kalitesini artırmayı hedeflemektedir. Sokakları daha yaşanabilir hale getirmek, meydanlarda toplumsal etkileşimi güçlendirmek, yerel pazarların iyileştirilip canlanmasına destek olmak, ihmal edilen alanları nitelikli yerlere dönüştürmek, parkları ve yeşil alanları artırarak sürdürülebilir kentsel çevre oluşumuna katkı sağlamak ana hedeflerdir.",
      sira: 1,
      id: "8a1cccad-c356-433e-145e-08dd26706eb0",
    },
    {
      baslik: "DENEME213",
      altBaslik: "asdasdas",
      aciklama: "deneme deneme deneme deneme deneme deneme deneme",
      sira: 2,
      id: "8c1ff37a-369a-4574-145f-08dd26706eb0",
    },
    {
      baslik: "NE ZAMAN?",
      altBaslik: "",
      aciklama:
        "Güzel İzmir Hareketi'nin başlangıç tarihi, şu anda planlama ve hazırlık aşamasında olan projelerin tamamlanmasına bağlı olarak belirlenecektir. İlk adımların atılması için gerekli altyapı çalışmaları ve katılımcıların mobilizasyonu devam etmektedir. Hareket ortak karar doğrultusunda eş zamanlı program ve projeleri hayata geçirecektir. ",
      sira: 3,
      id: "8c1ff37a-369a-4574-145f-08dd26706eb0",
    },
  ];

  //const sortedItems = [...data].sort((a, b) => a.sira - b.sira);

  const sortedItems = [...hakkimizdaBasliklar].sort((a, b) => a.sira - b.sira);

  return (
    <div className={styles.container}>
      {/* Üst taraftaki görsel bölüm */}
      <div className={styles.gorsel}>
        <img
          src={hakkimizdaGorsel?.kapakGorsel || "/assets/AboutLayer.png"}
          alt="Hakkımızda"
        />
      </div>

      {/* Alt taraftaki içerik bölümü */}
      <div className={styles.icerik}>
        {sortedItems.map((item) => (
          <div className={styles.item} key={item.id}>
            <div className={styles.baslik}>
              <h1>{item.baslik}</h1>
            </div>
            <div className={styles.aciklama}>
              <h2>{item.altBaslik}</h2>
              <p>{richTextRenderer(item.aciklama)}</p>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default AboutPage;
